export * from './quickpay_payment_view.component';